import {ActionTypes} from "../constants/action-types";

const INITIAL_STATE = { all: [], requiredAssessments: [] };

// eslint-disable-next-line
export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case ActionTypes.SET_POOL_POSITION_DATA:
            // check that data does exist
            if (action && action.payload) {
                // check if the data is already in the state
                const isInState = state.all.some(item => item.pool?.name === action.payload.pool?.name);
                // if the data is not in the state, add it
                if (!isInState) {
                    return {
                        ...state,
                        all: [
                            ...state.all,
                            action.payload,
                        ],
                        requiredAssessments: [
                            ...new Set([...state.requiredAssessments,
                                ...(Array.isArray(action.payload.pool?.required_assessments)
                                ? action.payload.pool?.required_assessments
                                : []), // Default to an empty array if it's not iterable
                            ]),
                        ],
                    };
                }
            }
            return state;
        default:
            return state;
    }
}
